import React from 'react'
import ReactDOM from 'react-dom'

import './spinner.scss'

const Spinner = () => (<div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>)

export default Spinner;


